import api from "../globals/axios";
import {
    SET_USER_MESSAGING_TOKEN,
} from "../globals/endpoints";

export async function setUserMessagingToken(token) {
    /*
    This function is used to set the messaging token for the user. This token is used to send push notifications to the user.
    */
    const currentStoredToken = sessionStorage.getItem("messagingToken");
    if (currentStoredToken === token) {
        return;
    }

    const response = await api.post(SET_USER_MESSAGING_TOKEN, { token });
    sessionStorage.setItem("messagingToken", token);
    return response.data;
};
